<section class="centered-with-padding flex flex-col gap-y-4 py-7">
  @if (data.titleWithText; as titleWithText) {
    <app-card-title-text-html [title]="titleWithText.title" [text]="titleWithText.text" />
  }
  @if (data.youtubeContent; as youtubeContent) {
    <div class="flex flex-col gap-y-3 rounded-xl bg-purple p-6">
      <app-title [title]="youtubeContent.title" size="custom-18-35" />
      <div class="aspect-video overflow-hidden rounded-2xl">
        <app-youtube-player [videoId]="youtubeContent.link | youtubeIdExtractor" />
      </div>
    </div>
  }
  @if (data.cta; as cta) {
    <app-button [label]="cta.label" [url]="cta.url" class="self-center" />
  }
</section>
